<template>
  <div class="page __bc-f2">
    <!-- 页面下拉刷新 -->
    <cp-page-refresh @refresh="refresh" ref="pageRefresh">
    <!-- 公共头部组件 -->
    <common-header />
    <div class="container">
      <!-- swiper新闻 -->
      <base-swiper
        v-if="bannerList.length"
        :list="bannerList"
        class="video-swiper"
        :showBottomMask="true"
        :autoplay="autoplay"
        @handle-click-slide="handleClickSlide"
      />
      <!-- 简介概要 -->
      <brief-intro v-if="orgVideoList.length || introduce" :list="orgVideoList" :introduce="introduce"/>
      <!-- 组织成员 -->
      <org-members v-if="orgMemberList.length"  :list="orgMemberList" />
      <!-- 精彩专题 -->
      <wonderful-topic v-if="bannerTopicList.length" :list="bannerTopicList" />
      <!-- 服务专区 -->
      <service-tabs v-if="serviceList.length" :list="typeList" @change-tab="changeTabs" ref="serveTabs">
         <!-- :content="serviceList" -->
        <service-content :list="serviceList"/>
      </service-tabs>
      <!-- 精选活动 -->
      <wonderful-activity v-if="bannerActivityList.length" :list="bannerActivityList" />
      <!-- 联系我们 -->
      <contact-us :list="bannerActivityList"/>
    </div>
    </cp-page-refresh>
    <!-- 公共底部tabs -->
    <foot-table />
  </div>
</template>

<script>
import CommonHeader from '@/views/layout/common-header'
import FootTable from '@/views/layout/foot-table'
import BaseSwiper from '@/views/components/base-swiper'
import WonderfulTopic from './components/wonderful-topic'
import OrgMembers from './components/org-members'
import { common, building } from '@/agent'
import WonderfulActivity from './components/wonderful-activity'
import BriefIntroduction from './components/brief-introduction'
import ContactUs from './components/contact'
import ServiceTabs from './components/service-tabs'
import ServiceContent from './components/service-content'
import Dict from '@/core/dict'

// import Service from './components/service.vue'
// import CommonTabs from '@/views/components/common-tabs'
export default {
  components: {
    'foot-table': FootTable,
    'common-header': CommonHeader,
    'base-swiper': BaseSwiper,
    'wonderful-topic': WonderfulTopic,
    'org-members': OrgMembers,
    'wonderful-activity': WonderfulActivity,
    'brief-intro': BriefIntroduction,
    'contact-us': ContactUs,
    'service-tabs': ServiceTabs,
    'service-content': ServiceContent,
    // 'service': Service,
    // 'common-tabs': CommonTabs,
  },
  data () {
    return {
      bannerList: [], // banner列表
      bannerTopicList: [], // 精选事件banner列表
      bannerActivityList: [], // 精选活动banner列表
      orgMemberList: [], // 组织成员列表
      orgVideoList: [], // 视频列表
      introduce: '',
      serviceList: [],
      typeList: [],
      newsParam: {
        query: {
          typeId: ''
        },
        pageNum: 1,
        pageSize: 20,
        sorts: [{ sortPropertyName: 'modifyTime', sortType: 'DESC' }]
      }, // 服务内容请求参数
      currentIndex: 0, // 当前事记分类swiper的列
    }
  },
  mounted () {
    this.$loading.show()
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    // 设置滚动条位置
    const scrollTop = Math.abs(document.querySelector('.page').getBoundingClientRect().top)
    this.$util.setTabsLeaveSite(from.path, scrollTop)
    next()
  },
  methods: {
    // 初始化
    async init () {
      await this.FindBannerListByReceive()
      this.$loading.hide()
    },
    // 下拉刷新页面
    refresh () {
      this.$refs.serveTabs.changeTabs(0) // 设置服务专区默认选中第一个
      Object.assign(this.$data, this.$options.data()) // 重置data对象的数据为初始状态
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
      this.init()
    },
    // 头部轮播图api
    async FindBannerListByReceive () {
      const reqData = {
        query: {
          typeId: 12 // 待完善
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'orderNbr', sortType: 'DESC' }]
      }
      const result = await common.findBannerListByReceive(reqData)
      this.bannerList = [...result.data.list]
      this.bannerList = this.bannerList.map(item => {
        // 1图片，2视频
        item.bgVideo = item.categoryType == 2 ? item.src : ''
        item.imgSrc = item.categoryType == 1 ? item.src : ''
        return item
      })
      this.autoplay = this.bannerList.length > 1
      this.findMemorabiliaListByReceive()
    },

    // 视频取值
    async findMemorabiliaListByReceive () {
      const result = await building.findOrgByReceive()
      this.orgVideoList = [...result.data.videos]
      // let obj = {
      //   src: 'group1/M00/00/1F/rBB5FWDrvaGAINXkAGk-cQOW7bU465.mp4'
      // }
      // this.orgVideoList[0] = obj
      // this.orgVideoList[1] = obj

      this.introduce = result.data.introduce
      this.findOrgByReceive()
    },
    // 组织成员取值
    async findOrgByReceive () {
      const result = await building.findOrgByReceive()
      this.orgMemberList = [...result.data.members]
      this.FindBannerListByReceiveStory()
    },
    // 精选事件轮播图api
    async FindBannerListByReceiveStory () {
      const reqData = {
        query: {
          typeId: 13 // 待完善
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'orderNbr', sortType: 'DESC' }]
      }
      const result = await common.findBannerListByReceive(reqData)
      this.bannerTopicList = [...result.data.list]
      this.findActivityByReceive()
    },
    // 精选活动轮播图api
    async findActivityByReceive () {
      const reqData = {
        query: {
        },
        pageNum: 1,
        pageSize: 10,
        sorts: [{ sortPropertyName: 'modifyTime', sortType: 'DESC' }]
      }
      const result = await building.findActivityByReceive(reqData)
      this.bannerActivityList = [...result.data.list]
      this.FindNewsType()
    },
    // 资讯标题分类api
    async FindNewsType () {
      const result = await building.findServiceTab()
      this.typeList = [...result.data]
      this.newsParam.query.typeId = this.typeList[this.currentIndex]['dictValue']
      this.FindPagePart()
    },
    // 分类新闻列表api；resetList重置list:[]再赋值
    async FindPagePart () {
      const result = await building.findServiceContent(this.newsParam)
      this.serviceList = result.data.list
    },
    changeTabs (index) {
      this.currentIndex = index
      this.newsParam.query.typeId = this.typeList[index]['dictValue']
      this.FindPagePart(true)
    },
    // 上滑加载
    load () {
      this.FindPagePart()
    },
    // 点击新闻swiper
    handleClickSlide (currentIndex) {
      const item = this.bannerList[currentIndex]
      this.formatBannerRouteTarget(item)
    },

    // 轮播图路由跳转处理
    formatBannerRouteTarget (item) {
      // jumpType = 1：外链；2：课程；3：详情
      console.log(item.jumpType)
      console.log(item.chapterId)
      if (item.jumpType === 1) {
        if (item.url) {
          this.$router.push({
            path: '/content-webview',
            query: { url: encodeURIComponent(item.url), type: Dict.linkType.iframe }
          })
        }
      } else if (item.jumpType === 2) {
        this.$router.push({
          path: '/course/detail',
          query: {
            id: item.chapterId,
            backPath: 'story',
            type: Dict.pageType.inform,
            // tabIndex: this.tabIndex
          }
        })
      } else if (item.jumpType === 3) {
        this.$router.push({
          path: '/story/detail',
          query: {
            id: item.id,
            type: Dict.pageType.advertisement // 根据类型，在详情页调不同接口
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
.service_content{
  padding: 24px 20px 0px 24px;
  .service_title {
    width: 100%;
    height: 16px;
    opacity: 1;
    font-size: 17px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #1c1f25;
    line-height: 24px;
  }
  .service_summary {
    width: 287px;
    height: 30px;
    opacity: 1;
    font-size: 12px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #828282;
    line-height: 18px;
  }
  .service_img {
    width: 287px;
    height: 161px;
    opacity: 1;
  }
}
.container {
  padding: $header-height 0 $foot-table-height;
  // common-tabs组件背景色未吸顶灰色，吸顶白色
  /deep/.van-tabs__nav--line {
    background-color: #f2f2f2;
  }
   /deep/.van-sticky--fixed .van-tabs__nav--line {
    background-color: #fff;
  }
}
.text-1 {
  position: relative;
  text-align: center;
  background-color: $main-color;
  color: #fff;
  &:nth-child(1) {
    width: 105px;
    height: 30px;
    opacity: 0.4;
    background: #33a353;
  }
}
</style>
